import React, { useContext, useEffect } from 'react';
import classes from './OnboardingStep.module.scss';
import classNames from 'classnames';
import { Icon } from '../../../components/images/Icon/Icon';
import { IconsEnum } from '../../../constants/icons';
import { OnboardingContext } from '../states/OnboardingProvider';
import { AppContext } from '../../../providers/AppProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProgresStepType } from '../constants/content';
import { getOnboardingStepName } from '../helpers/getStepLabel';
import { isPostEditorActive } from '../helpers/isPostEditorActive';
import { PostSource, useSeeOnboardingStepMutation } from '../../../models/graphql';
import { useOpenPostEditor } from '../../../hooks/useOpenPostEditor';
import { useClosePostEditor } from '../../../hooks/useClosePostEditor';
import { useUserData } from '../../../hooks/useUserData';
import { TopNavContext } from '../../../providers/TopNavProvider';

export type OnboardingStepViewProps = {
  //
  step: ProgresStepType;
  index: number;
  // action: VoidFunction;
};

export const OnboardingStepView = (props: OnboardingStepViewProps): JSX.Element => {
  const { pathname: currentRoute } = useLocation();
  const navigate = useNavigate();
  const { index, step } = props;
  const { state, dispatch } = useContext(OnboardingContext);
  const { state: topNavState } = useContext(TopNavContext);
  const { postEditorContext } = useContext(AppContext);
  const { userData } = useUserData();
  const { id: userId } = userData || { id: undefined };
  const { version } = state;
  const postEditorActive = isPostEditorActive(postEditorContext);
  const active = postEditorActive ? step.route === '' : currentRoute === step.route;
  const checked = step.completed;
  const label = getOnboardingStepName(version, index);
  const [markAsSeenMuation] = useSeeOnboardingStepMutation();
  const { openNewPost: openNewPostHandler } = useOpenPostEditor();
  const { closePostEditor } = useClosePostEditor();

  const action = () => {
    if (!userId) return;
    if (step.route === '' && !postEditorActive) {
      const openNewPost = () =>
        openNewPostHandler({
          source: PostSource.POST_EDITOR,
          onClose: topNavState.newPostCloseCallback
        });
      dispatch({
        type: 'gotoStep',
        payload: {
          index,
          action: markAsSeenMuation,
          openNewPost,
          userId
        }
      });
    } else if (step.route && step.route !== currentRoute) {
      navigate(step.route);
    } else if (step.route && step.route === currentRoute && postEditorActive) {
      closePostEditor();
    }
  };

  // for non post editor steps we dispatch gotoStep action, for post editor we'll need to just set the activeStepIndex
  useEffect(() => {
    if (!userId) return;
    if (postEditorActive && active) {
      dispatch({ type: 'setActiveStepIndex', payload: index });
    } else if (!postEditorActive && active) {
      dispatch({
        type: 'gotoStep',
        payload: {
          index,
          action: markAsSeenMuation,
          userId
        }
      });
    }
  }, [active, dispatch, index, markAsSeenMuation, postEditorActive, userId]);

  const wrapperClasses = classNames(classes.OnboardingStep, 'grid-x align-justify align-middle', {
    [classes.OnboardingStepActive]: active
  });
  return (
    <button className={wrapperClasses} onClick={() => action()}>
      <div
        className={classNames(classes.Tick, active ? classes.TickActive : checked ? classes.TickChecked : undefined)}>
        <Icon size={'medium'} name={IconsEnum.tick} />
      </div>
      <div className={classNames('cell', 'shrink', classes.Label)}>{label}</div>
    </button>
  );
};
